import { Routes } from '@angular/router';
import { StoreLayoutComponent } from '@/layout/store-layout/store-layout.component';
import { CustomerAddressService } from './customer-address/services/customer-address.service';
import { CartNotEmptyGuard } from './cart/guards/checkout.guard';
import { OrderService } from './order/services/order.service';
import { checkoutResolver } from './cart/resolvers/checkout.resolve';
import { ProfileCustomerComponent } from './profile/components/profile-customer/profile-customer.component';
import { ProfileLayoutComponent } from './profile/components/profile-layout/profile-layout.component';
import { authActivateChildGuard } from './auth/guards/auth.guard';
import { inject } from '@angular/core';
import { ConfigService } from './config/config.service';
import { homeEnabledGuard } from './home/guards/home.guard';

export const routes: Routes = [
  {
    path: '',
    component: StoreLayoutComponent,
    data: {
      breadcrumb: {
        label: 'Inicio',
      },
    },
    children: [
      {
        path: '',
        redirectTo: () => {
          const homeEnabled = inject(ConfigService).getHomeConfig().enabled;
          return homeEnabled ? 'inicio' : 'productos';
        },
        pathMatch: 'full',
      },
      {
        path: 'inicio',
        canActivate: [homeEnabledGuard],
        loadChildren: () => import('./home/home.routes'),
      },
      {
        path: 'productos',
        loadChildren: () => import('./products/products-routes'),
        data: {
          preload: true,
          breadcrumb: {
            label: 'Productos',
          },
        },
      },
      {
        path: 'usuario',
        component: ProfileLayoutComponent,
        canActivateChild: [authActivateChildGuard],
        data: {
          breadcrumb: {
            label: 'Perfil',
          },
        },
        children: [
          {
            path: '',
            component: ProfileCustomerComponent,
          },
          {
            path: 'direcciones',
            loadChildren: () =>
              import('./customer-address/customer-address-routes'),
            providers: [CustomerAddressService],
          },
          {
            path: 'ordenes',
            loadChildren: () => import('./order/order-routes'),
            providers: [OrderService],
            data: {
              breadcrumb: {
                label: 'Pedidos',
              },
            },
          },
        ],
      },
      {
        path: 'checkout',
        resolve: {
          routeData: checkoutResolver,
        },
        loadChildren: () => import('./cart/cart-routes'),
        canActivate: [CartNotEmptyGuard],
        providers: [CustomerAddressService],
      },
      {
        path: 'pago-cancelado-enzona',
        loadComponent: () =>
          import('./cart/components/enzona-canceled/enzona-canceled.component').then(
            mod => mod.EnzonaCanceledComponent
          ),
        data: {
          breadcrumb: {
            label: 'Pago Cancelado',
          },
        },
      },
      {
        path: 'orden-registrada/:id',
        data: {
          breadcrumb: {
            label: 'Pedido Registrado',
          },
        },
        providers: [OrderService],
        loadComponent: () =>
          import('./order/templates/order-completed/order-completed-template.component').then(
            mod => mod.OrderCompletedTemplateComponent
          ),
      },
      {
        path: 'preguntas-frecuentes',
        data: {
          breadcrumb: {
            label: 'Preguntas frecuentes',
          },
        },
        loadComponent: () =>
          import('./pages/faq/faq.component').then(mod => mod.FaqComponent),
      },
      {
        path: 'sobre-nosotros',
        data: {
          breadcrumb: {
            label: 'Sobre nosotros',
          },
        },
        loadComponent: () =>
          import('./pages/about-us/about-us.component').then(
            mod => mod.AboutUsComponent
          ),
      },
      {
        path: 'terminos-condiciones',
        data: {
          breadcrumb: {
            label: 'Términos y condiciones de uso',
          },
        },
        loadComponent: () =>
          import('./pages/terms-and-conditions/terms-and-conditions.component').then(
            mod => mod.TermsAndConditionsComponent
          ),
      },
      {
        path: 'politica-privacidad',
        data: {
          breadcrumb: {
            label: 'Políticas de privacidad',
          },
        },
        loadComponent: () =>
          import('./pages/privacy-policy/privacy-policycomponent').then(
            mod => mod.PrivacyPolicyComponent
          ),
      },
    ],
  },
  {
    path: 'seguridad',
    loadChildren: () => import('./auth/auth-routes'),
  },
  {
    path: '**',
    data: {
      breadcrumb: {
        label: 'Página no encontrada',
      },
    },
    loadComponent: () =>
      import('./pages/not-found/not-found.component').then(
        mod => mod.NotFoundComponent
      ),
  },
];
